import { useEffect } from 'react';
import { MfeConfig } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import CarvanaHeader from '@carvana/header';
import mfeConfig from 'Utils/mfeConfig';

const Header = () => {
  useEffect(() => MfeConfig(mfeConfig), []);

  return (
    <MfeReactComponent
      module="HeaderModule"
      component="default"
      environment={process.env.NODE_ENV}
      shouldLoadPlugin={false}
      useProvider
      loading={<CarvanaHeader environment={process.env.NODE_ENV} />}
    />
  );
};

export default Header;
